import { AxiosInstance } from 'axios'

export type GeneralServiceCategoriesDto = {
  data: GeneralServiceCategoriesItemDto[]
}
export type GeneralServiceCategoriesItemDto = {
  id: number
  attributes: {
    name: string
    slug: string
    parent_category: {
      data: GeneralServiceCategoriesItemDto | null
    }
    child_categories: {
      data: GeneralServiceCategoriesItemDto[]
    }
  }
}

export type GetAllServiceCategoriesArgs = {
  locale: string
  isRoot: boolean
}

export const getAllServiceCategories = async (
  client: AxiosInstance,
  { locale, isRoot }: GetAllServiceCategoriesArgs,
) => {
  const path = `/service-categories`
  const params = {
    locale,
    fields: ['name', 'slug'],
    filters: {
      $and: [
        isRoot
          ? {
              parent_category: {
                id: {
                  $null: true,
                },
              },
            }
          : {},
      ],
    },
    populate: {
      parent_category: {
        fields: ['name', 'slug'],
      },
      child_categories: {
        fields: ['name', 'slug'],
      },
    },
  }
  return (await client.get<GeneralServiceCategoriesDto>(path, { params })).data.data
}
